interface ITrack {
  type: "init" | "step" | "finish" | "custom";
  data: object;
}

export const track = (track: ITrack): void => {
  const stepEvent = new CustomEvent("rumbledirect-track", { detail: track });
  dispatchEvent(stepEvent);
};
